module.exports = __webpack_public_path__ + "img/remove.e87b1761.svg";